export enum Type {
  SLIDER_GROUP = 'SLIDER_GROUP',
  SLIDER = 'SLIDER',
  SELECTION = 'SELECTION',
  DYNAMIC_TEXT = 'DYNAMIC_TEXT',
  ORGANIZATION_UNIT_COOPERATION_SELECTION = 'ORGANIZATION_UNIT_COOPERATION_SELECTION',
  SLIDER_DROPDOWN = 'SLIDER_DROPDOWN',
  SLIDER_DROPDOWN_GROUP = 'SLIDER_DROPDOWN_GROUP',
  BOOLEAN_SELECTION = 'BOOLEAN_SELECTION',
  NUMBER_INPUT = 'NUMBER_INPUT',
  DYNAMIC_NUMBER_DESCRIPTION_AMOUNT_INPUT = 'DYNAMIC_NUMBER_DESCRIPTION_AMOUNT_INPUT',
  AMOUNT_TOGGLE_INPUT = 'AMOUNT_TOGGLE_INPUT',
  ORGANIZATION_UNIT_NUMBER_INPUT = 'ORGANIZATION_UNIT_NUMBER_INPUT',
  DYNAMIC_OPTIONS_WITH_NUMBER_AND_SELECTION_OPTION = 'DYNAMIC_OPTIONS_WITH_NUMBER_AND_SELECTION_OPTION',
  DYNAMIC_OPTIONS_WITH_NUMBER_AND_SELECTION = 'DYNAMIC_OPTIONS_WITH_NUMBER_AND_SELECTION',
}

// core adds the basic properties to all elements

export type Core<T> = {
  uuid: string
  type: T
}

// slider group used for multiple slider elements dependant on each other

export type SliderGroup = Core<Type.SLIDER_GROUP> & {
  sliders: Slider[]
}

// slider used for percentage questions

export type Slider = Core<Type.SLIDER> & {
  value: number
}

// selection used for single or multiple choice questions

export type Selection = Core<Type.SELECTION> & {
  selectedOptions: string[]
}

// dynamic text used for multiple single line text inputs

export type DynamicTextAnswer = {
  uuid: string
  value: string
}

export type DynamicText = Core<Type.DYNAMIC_TEXT> & {
  textAnswers: DynamicTextAnswer[]
}

// organization unit cooperation selection used for selecting one or multipe organization unit's often used for cooperation

export type OrganizationUnitCooperationSelectionPrio = {
  organizationUnitUUID: string
  priority: number
}

export type OrganizationUnitCooperationSelection = Core<Type.ORGANIZATION_UNIT_COOPERATION_SELECTION> & {
  organizationUnitPrioSelectionList: OrganizationUnitCooperationSelectionPrio[]
}

// slider dropdown used for slider with dropdown options

export type SliderDropdown = Core<Type.SLIDER_DROPDOWN> & {
  value: number
  optionUUID: string
}

// slider dropdown group used for multiple slider elements dependant on each other with dropdowns

export type SliderDropdownGroup = Core<Type.SLIDER_DROPDOWN_GROUP> & {
  sliderDropdowns: SliderDropdown[]
}

// boolean selection used for yes/no questions

export type BooleanSelection = Core<Type.BOOLEAN_SELECTION> & {
  selectionValue: 'yes' | 'no'
}

// number input used for number questions

export type NumberInput = Core<Type.NUMBER_INPUT> & {
  number: number
}

// dynamic number amount description input used for number questions with dynamic description

export type DynamicNumberDescriptionAmountInputAnswer = {
  uuid: string
  description: string
  amount: number
  number: number
}

export type DynamicNumberDescriptionAmountInput = Core<Type.DYNAMIC_NUMBER_DESCRIPTION_AMOUNT_INPUT> & {
  numberAnswers: DynamicNumberDescriptionAmountInputAnswer[]
}

// dynamic number description input used for number questions with dynamic description

export type AmountToggleInput = Core<Type.AMOUNT_TOGGLE_INPUT> & {
  isEnabled: boolean
  amount: number
}

// dynamic number description input used for number questions with dynamic description

export type OrganizationUnitNumberInputItem = {
  organizationUnitUUID: string
  number: number
}

export type OrganizationUnitNumberInput = Core<Type.ORGANIZATION_UNIT_NUMBER_INPUT> & {
  organizationUnitNumberInputList: OrganizationUnitNumberInputItem[]
}

// selectable options with number input

export type DynamicOptionsWithNumberAndSelectionOption = Core<Type.DYNAMIC_OPTIONS_WITH_NUMBER_AND_SELECTION_OPTION> & {
  isActive: boolean
  name: string
  number: number
  isNormSelected: boolean
}

export type DynamicOptionsWithNumberAndSelection = Core<Type.DYNAMIC_OPTIONS_WITH_NUMBER_AND_SELECTION> & {
  dynamicOptionsWithNumberAndSelection?: DynamicOptionsWithNumberAndSelectionOption[]
}

export type Element =
  | SliderGroup
  | Slider
  | Selection
  | DynamicText
  | OrganizationUnitCooperationSelection
  | SliderDropdown
  | SliderDropdownGroup
  | BooleanSelection
  | NumberInput
  | DynamicNumberDescriptionAmountInput
  | AmountToggleInput
  | OrganizationUnitNumberInput
  | DynamicOptionsWithNumberAndSelection
  | DynamicOptionsWithNumberAndSelectionOption
